/* eslint-disable no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { paymentsAPI } from 'services/payments.service';
import { Loader, Buttons } from 'components';
import { StripeForm } from './StripeForm';
import { Palette } from 'config';
import styled from 'styled-components';

const stripePromise = loadStripe(window.stripe_key);

export const CreditCards = () => {
  const { data, isError, isFetching } = paymentsAPI.useGetPaymentsDetailsQuery();

  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    if (data?.creditHolderDetails?.maskedNumber ?? false) {
      setIsEditMode(true);
    }
  }, [isFetching]);

  if (isError) {
    return <div>Error</div>;
  }

  if (isFetching) {
    return (
      <div style={{ height: '210px', display: 'flex', alignItems: 'center' }}>
        <Loader.Local delay={0} />
      </div>
    );
  }

  if (isEditMode) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <section>
          <SmallText>
            Current active credit card: {data?.creditHolderDetails?.brand ?? 'no name'}
          </SmallText>
          <SmallText>Ending with {data?.creditHolderDetails?.maskedNumber}</SmallText>
          <SmallText>Expires on {data?.creditHolderDetails?.expirationDate}</SmallText>
        </section>
        <Buttons.SecondaryNormal onClick={() => setIsEditMode(false)}>
          Change
        </Buttons.SecondaryNormal>
      </div>
    );
  }

  return (
    <Elements stripe={stripePromise} options={{}}>
      <StripeForm
        setIsEditMode={setIsEditMode}
        isHideCancel={Boolean(data?.creditHolderDetails?.maskedNumber) ?? true}
      />
    </Elements>
  );
};

const SmallText = styled.p`
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._700};
`;
